import React from 'react';

import { SVGComponentProps } from './svg.types';

const SortAscSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="1" y="10" width="10" height="2" rx="1" fill={fill} />
      <path
        d="M1 7C1 6.44772 1.44772 6 2 6H7C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8H2C1.44772 8 1 7.55228 1 7Z"
        fill={fill}
      />
      <path
        d="M1 3C1 2.44772 1.44772 2 2 2H5C5.55228 2 6 2.44772 6 3C6 3.55228 5.55228 4 5 4H2C1.44772 4 1 3.55228 1 3Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5389 3.94907L11.7725 3.06887L11.7619 5.69546C11.7618 5.73565 11.7547 5.77541 11.741 5.81248C11.7273 5.84955 11.7073 5.88319 11.6821 5.91147C11.657 5.93976 11.6272 5.96214 11.5944 5.97733C11.5616 5.99252 11.5265 6.00022 11.4911 6C11.4557 5.99981 11.4207 5.99171 11.388 5.97615C11.3554 5.9606 11.3258 5.9379 11.3009 5.90935C11.276 5.8808 11.2563 5.84697 11.243 5.80978C11.2296 5.77258 11.2228 5.73277 11.223 5.6926L11.2333 3.06659L10.4591 3.93507C10.434 3.96338 10.4042 3.98579 10.3715 4.00102C10.3387 4.01626 10.3036 4.02402 10.2682 4.02386C10.2329 4.0237 10.1978 4.01562 10.1652 4.00009C10.1326 3.98456 10.1029 3.96189 10.078 3.93335C10.0277 3.87567 9.99967 3.79769 10 3.71653C10.0003 3.63538 10.029 3.5577 10.0798 3.50054L11.3506 2.07212C11.3925 2.02541 11.4489 1.99947 11.5076 2.00001C11.5663 2.00054 11.6223 2.02751 11.6635 2.07498L12.922 3.51854C12.9723 3.57618 13.0003 3.65411 13 3.73522C12.9997 3.81632 12.971 3.89396 12.9202 3.95107C12.8951 3.97936 12.8653 4.00176 12.8325 4.01697C12.7997 4.03219 12.7646 4.03992 12.7292 4.03974C12.6938 4.03955 12.6588 4.03145 12.6261 4.01589C12.5935 4.00033 12.5638 3.97763 12.5389 3.94907Z"
        fill={fill}
      />
    </svg>
  );
};

export default SortAscSVG;
